import { render, staticRenderFns } from "./VehicleClassPerformanceSubMenu.vue?vue&type=template&id=7fb3b206&"
import script from "./VehicleClassPerformanceSubMenu.vue?vue&type=script&lang=js&"
export * from "./VehicleClassPerformanceSubMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports